import { useEffect, useState } from "react";
import CustomButton from "../../components/commons/CustomBtn";
import Container from "../../components/Container/Container";
import CrawlerBody from "./components/CrawlerBody";
import CrawlerHeader from "./components/CrawlerHeader";
import axios from "axios";
import toast from "react-hot-toast";
import mainAxios from "../../redux/api/mainAxios";

const Crawler = () => {
  const [crawler, setCrawler] = useState([]);
  const token = localStorage.getItem("token");
  const [filter, setFilter] = useState("actif");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchCrawler = async () => {
      try {
        const response = await mainAxios.get(`api/api-listes`);

        if (
          response.data &&
          response.data.data &&
          response.data.meta &&
          response.data.meta.pagination
        ) {
          setCrawler(response.data);
        } else {
          console.error("Invalid API response structure:", response.data);
          toast.error("Réponse API invalide");
        }
      } catch (error) {
        console.error("error", error);
        toast.error("Erreur lors de la récupération des crawlers");
      }
    };
    fetchCrawler();
  }, [token, filter]);

  const crawlerLength =
    (crawler?.data?.length || 0) * (crawler?.meta?.pagination?.pageCount || 0);

  return (
    <Container>
      <div className="d-flex gap10">
        <CustomButton
          label="Crawlers"
          contentType1="Trouvés"
          contentLength1={crawlerLength}
          contentLengthClass={`${
            crawlerLength === 0 ? "regular fs11 white" : "regular fs11 pink"
          }`}
          buttonClass={`${"bg-white radiusTop5 px-20 py-10 "} `}
          labelClass={`${"pink fs16 semibold text-capitalize text-start"}`}
        />
      </div>
      <CrawlerHeader
        setFilter={setFilter}
        filter={filter}
        search={search}
        setSearch={setSearch}
      />
      <CrawlerBody
        search={search}
        setSearch={setSearch}
        crawlerList={crawler}
        crawler={crawler}
        setCrawler={setCrawler}
      />
    </Container>
  );
};

export default Crawler;
